var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: -384,
    y: -320,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons1",
    serifId: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strike"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "H3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-ul"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hamburger-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-ol"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-task"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vertical-menu"
  }), /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sidebar-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pen1",
    serifId: "Pen"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }), /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hr"
  }), /*#__PURE__*/React.createElement("g", {
    id: "info"
  }), /*#__PURE__*/React.createElement("g", {
    id: "warning"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vue"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cog"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }), /*#__PURE__*/React.createElement("g", {
    id: "toggle-off"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shredder"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.89,30.496c-1.14,1.122 -1.784,2.653 -1.791,4.252c-0.006,1.599 0.627,3.135 1.758,4.266c3.028,3.028 7.071,7.071 10.081,10.082c2.327,2.326 6.093,2.349 8.448,0.051c5.91,-5.768 16.235,-15.846 19.334,-18.871c0.578,-0.564 0.905,-1.338 0.905,-2.146c0,-4.228 0,-17.607 0,-17.607l-17.22,0c-0.788,0 -1.544,0.309 -2.105,0.862c-3.065,3.018 -13.447,13.239 -19.41,19.111Zm34.735,-15.973l0,11.945c0,0.811 -0.329,1.587 -0.91,2.152c-3.069,2.981 -13.093,12.718 -17.485,16.984c-1.161,1.127 -3.012,1.114 -4.157,-0.031c-2.387,-2.386 -6.296,-6.296 -8.709,-8.709c-0.562,-0.562 -0.876,-1.325 -0.872,-2.12c0.003,-0.795 0.324,-1.555 0.892,-2.112c4.455,-4.373 14.545,-14.278 17.573,-17.25c0.561,-0.551 1.316,-0.859 2.102,-0.859c3.202,0 11.566,0 11.566,0Zm-7.907,2.462c-1.751,0.015 -3.45,1.017 -4.266,2.553c-0.708,1.331 -0.75,2.987 -0.118,4.356c0.836,1.812 2.851,3.021 4.882,2.809c2.042,-0.212 3.899,-1.835 4.304,-3.896c0.296,-1.503 -0.162,-3.136 -1.213,-4.251c-0.899,-0.953 -2.18,-1.548 -3.495,-1.57c-0.031,-0.001 -0.062,-0.001 -0.094,-0.001Zm0.008,2.519c1.105,0.007 2.142,0.849 2.343,1.961c0.069,0.384 0.043,0.786 -0.09,1.154c-0.393,1.079 -1.62,1.811 -2.764,1.536c-1.139,-0.274 -1.997,-1.489 -1.802,-2.67c0.177,-1.069 1.146,-1.963 2.27,-1.981c0.014,0 0.029,0 0.043,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.625,13.137l0,4.001l3.362,0l0,11.945c0,0.811 -0.328,1.587 -0.909,2.152c-3.069,2.981 -13.093,12.717 -17.485,16.983c-1.161,1.128 -3.013,1.114 -4.157,-0.03l-0.034,-0.034l-1.016,0.993c-0.663,0.646 -1.437,1.109 -2.259,1.389l1.174,1.174c2.327,2.327 6.093,2.35 8.447,0.051c5.91,-5.768 16.235,-15.845 19.335,-18.87c0.578,-0.565 0.904,-1.339 0.904,-2.147c0,-4.227 0,-17.607 0,-17.607l-7.362,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "spinner--loading--dots-",
    serifId: "spinner [loading, dots]"
  }), /*#__PURE__*/React.createElement("g", {
    id: "react"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.ddf45f5c4d668f384120638d74872dc4.svg";
export { ForwardRef as ReactComponent };